// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XvoJU{height:100%;justify-content:center}.XvoJU,.XvoJU span{align-items:center;display:flex}.XvoJU span button{background-color:#0000!important;margin:0 .25rem!important}.XvoJU span button i.an6LN{font-size:20px;font-size:1.25rem}.XvoJU span .phoMT{top:1.6px;top:.1rem}.XvoJU span .phoMT label:after{background-color:#1cb5ac!important;opacity:.5}.XvoJU span .phoMT label:before{opacity:.5;transition:opacity .25s ease-in-out}.XvoJU span .vgibu{top:1.6px;top:.1rem}.XvoJU span .vgibu label:before{background-color:#ffffff80!important;opacity:.5;transition:opacity .25s ease-in-out}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `XvoJU`,
	"sun": `an6LN`,
	"toggleDark": `phoMT`,
	"toggleLight": `vgibu`
};
module.exports = ___CSS_LOADER_EXPORT___;
